module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui form message"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Work: "), _c('span', [_vm._v(_vm._s(_vm.settings.workDuration))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.workDuration),
      expression: "settings.workDuration"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "range",
      "min": "0",
      "max": "60"
    },
    domProps: {
      "value": (_vm.settings.workDuration)
    },
    on: {
      "__r": function($event) {
        _vm.settings.workDuration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Break: "), _c('span', [_vm._v(_vm._s(_vm.settings.breakDuration))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.breakDuration),
      expression: "settings.breakDuration"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "range",
      "min": "0",
      "max": "60"
    },
    domProps: {
      "value": (_vm.settings.breakDuration)
    },
    on: {
      "__r": function($event) {
        _vm.settings.breakDuration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.settings))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b338060","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timer/Settings.vue
// module id = 23
// module chunks = 0